<template>
    <div class='container content'>

      <h1 v-if="!showErrorMessage">Hold on tight...</h1>

<span v-else>Oida, her gikk noe galt. Klikk <a href="/order">her</a> for å prøve igjen.</span>


    </div>
</template>
<script>
import Firebase from 'firebase';


export default {
    data(){
        return {
            orderDetails: false,
            hasPaid: null,
            showErrorMessage: false,
        };
    },
    created(){
        var charge_id = this.$route.params.id;
        this.chargeID = charge_id;
        var currentUserUID = Firebase.auth().currentUser.uid;

        Firebase.database().ref('/users/'+currentUserUID+'/hasPaid/').on('value', snapshot => {
                var hasPaid = snapshot.val();
                 if(hasPaid) {
                  window.location.replace('https://combine.no/'+'user');
                 } else {this.showErrorMessage = true};
               });
    },

}
</script>
 <style>

 .content{
   padding-top: 200px;
 }

 </style>



// WEBPACK FOOTER //
// src/components/Complete.vue